export default __webpack_public_path__ + "static/media/upload-dialog-loaded.5ed4136b.svg";